import { render, staticRenderFns } from "./ZarinPalTransaction.vue?vue&type=template&id=60637602&scoped=true&"
import script from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"
export * from "./ZarinPalTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60637602",
  null
  
)

export default component.exports